<div class="session-history-container">
  <div class="header-section">
    <h1>Session History</h1>
  </div>

  <div class="search-section">
    <p-iconfield iconPosition="left">
      <p-inputicon>
        <i class="pi pi-search"></i>
      </p-inputicon>
      <input
        type="text"
        pInputText
        placeholder="Search history..."
        (keyup)="sendFilterQuery($event)"
        [(ngModel)]="searchFilter"
        class="search-input" />
    </p-iconfield>
  </div>

  <div class="table-section">
    <app-besharp-table
      [tableItems]="sessions"
      [loading]="loading"
      [tableDefinitions]="tableDefinitions"
      [totalRecords]="totalCount"
      [pageRows]="10"
      [paginator]="true"
      [defaultActive]="'endDate'"
      [defaultDirection]="-1"
      [idColumnDef]="'id'"
      [showGridLines]="true"
      [pageRowsOptions]="[5, 10, 20]"
      [showStripes]="true"
      [rowOverEffect]="true"
      [showCurrentPageReport]="true"
      [currentPageReportTemplate]="'Showing {first} to {last} of {totalRecords} entries'"
      [showClearFiltersButton]="false"
      (rowClicked)="onRowClicked($event)"
      styleClass="custom-table"
    >
    </app-besharp-table>
  </div>
</div>

<p-toast></p-toast>
